import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from '../../services/config/config.service';
import { DataService } from '../../services/data/data.service';
import { ReportService } from '../../services/report/report.service';
import { SettingsService } from '../../services/settings/settings.service';

@Component({
	selector: 'pcm-page-reports',
	templateUrl: './page-reports.component.html',
	styleUrls: ['./page-reports.component.scss']
})
export class PageReportsComponent implements OnInit {
	public title = 'Reports';
	get currentPropName() { return this.reportService.getActiveTab(this.reportService.tabsData.tabs).prop; }

	public reports = {
		invoice: {
			dataConfigPropName: 'invoicereport',
			pageTitle: 'Export Invoice Report',
			dataConfig: undefined,
			pageData: { filename: 'invoiceReport.csv' },
			pageSubmit: (event) => this.reportService.exportInvoiceReports(event)
		},
		liability: {
			dataConfigPropName: 'liabilityreport',
			pageTitle: 'Export Liability Report',
			dataConfig: undefined,
			pageData: { filename: 'liabilityReport.csv' },
			pageSubmit: (event) => this.reportService.exportLiabilityReports(event)
		},
		timesheet: {
			dataConfigPropName: 'timesheetreport',
			pageTitle: 'Export ILC Hours Report',
			dataConfig: undefined,
			pageData: { filename: 'timesheetsReport.csv' },
			pageSubmit: (event) => this.reportService.exportTimesheetReports(event)
		},
		po: {
			dataConfigPropName: 'poreport',
			pageTitle: 'Export Purchase Order Remaining Fund Report',
			dataConfig: undefined,
			pageData: { filename: 'purchaseOrdersReport.csv', remainingpercentage: 20 },
			pageSubmit: (event) => this.reportService.exportPurchaseorderReports(event)
		},
		contractor: {
			dataConfigPropName: 'contractorreport',
			pageTitle: 'Export Expiring Contractors Report',
			dataConfig: undefined,
			pageData: { filename: 'expiringContractorsReport.csv' },
			pageSubmit: (event) => this.reportService.exportContractorReports(event)
		},
		ContractorNoTS: {
			dataConfigPropName: 'contractorNoTSreport',
			pageTitle: 'Export Contractors Not Claiming Report',
			dataConfig: undefined,
			pageData: { filename: 'contractorsNoTSReport.csv' },
			pageSubmit: (event) => this.reportService.exportContractorNoTSReports(event)
		},
		activeContractor: {
			dataConfigPropName: 'activecontractorreport',
			pageTitle: 'Export Active Contractors Report',
			dataConfig: undefined,
			pageData: { filename: 'activeContractorsReport.csv' },
			pageSubmit: (event) => this.reportService.exportActiveContractorReports(event)
		},
		ContractorMissTS: {
			dataConfigPropName: 'contractorMissTSreport',
			pageTitle: 'Export Contractors Missing Claims Report',
			dataConfig: undefined,
			pageData: { filename: 'contractorsMissTSReport.csv' },
			pageSubmit: (event) => this.reportService.exportContractorMissTSReports(event)
		}
	};

	userSettingsListener;

	constructor(
		private configService: ConfigService,
		public reportService: ReportService,
		private settingsService: SettingsService,
		public dataService: DataService,
		private route: ActivatedRoute
	) {}

	ngOnInit() {
		this.reportService.selectDefaultTab(this.reportService.tabsData.tabs);
		this.route.params.subscribe(params => {
			this.reportService.tabClick(undefined, params['initTab'], this.reportService.tabsData.tabs);
		});

		Object.entries(this.reports).forEach((reportsTuple) => {
			this.reports[reportsTuple[0]].dataConfig = this.configService.getDataObj(this.reports[reportsTuple[0]].dataConfigPropName);
		});

		this.settingsService.loadAllCountryCodes();		// populate dataService.countrycode
		this.settingsService.loadAllDivisionCodes();		// populate dataService.divisioncode
		this.reportService.loadAllSuppliers();		// populate dataService.suppliername

		// cost centers copies a list from user settings, so wait for user settings to be retrieved first
		this.userSettingsListener = this.dataService.userSettingsListener().subscribe(() => {
			this.settingsService.loadAllCostCenters();
		});
	}

	ngOnDestroy() {
		this.userSettingsListener.unsubscribe();
	}
}
